import { render, staticRenderFns } from "./GenericSelector.vue?vue&type=template&id=60b15516"
import script from "./GenericSelector.vue?vue&type=script&lang=js"
export * from "./GenericSelector.vue?vue&type=script&lang=js"
import style0 from "./GenericSelector.vue?vue&type=style&index=0&id=60b15516&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports